import googleMapsApiLoader from './loader';

class Geocoding {
  constructor() {
    this.#initializeGeocoding();
  }

  async #initializeGeocoding() {
    const { Geocoder } = await googleMapsApiLoader.importLibrary('geocoding');
    this.geocodingApi = new Geocoder();
  }

  async getLatLongFromAddress(address) {
    let location = null;

    await this.geocodingApi.geocode(
      { 'address': address},
      (results, status) => {
        if (status != 'OK') return;
        
        location = {
          latitude: results[0].geometry.location.lat(),
          longitude: results[0].geometry.location.lng(),
        };
      }
    );

    return location;
  }
}

export default Geocoding;